module.exports = __webpack_public_path__ + "assets/img/632222.ead997ce.png";